<template>
<layout-content>
  <template #toolbar>
    <data-time-query :query="query" />
    <site-device-query :options="filterSites" :query="query" />
    <el-button
      :disabled="canNotSearch"
      type="orange"
      size="small"
      icon="el-icon-search"
      @click="onSearchBtnClick"
    >查询</el-button>
  </template>

  <template #body>
    <data-wrapper>
      <el-table
        ref="table"
        :data="dataList"
        height="100%"
        border
        highlight-current-row
        header-row-class-name="custom-table-header"
        class="custom-table"
        style="width:100%"
      >
        <el-table-column label="日期" prop="dataTime" align="center" />
        <el-table-column label="站点" prop="siteName" />
        <el-table-column label="设备" prop="siteDeviceName" />
        <el-table-column label="因子" prop="deviceStatusName" />
        <el-table-column label="监测值" prop="value">
          <template slot-scope="{row}">{{row.value}} {{row.unit}}</template>
        </el-table-column>
        <el-table-column label="超标范围">
          <template slot-scope="{row}">{{row.alarmMin}}~{{row.alarmMax}} {{row.unit}}</template>
        </el-table-column>
      </el-table>
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseDateData from '../../../BaseDateData'
import DataWrapper from '../../../../components/Data/DataWrapper'

export default {
  name: 'OperationsFactorAlarmStatusExcessive',
  routeInfo: {
    label: '状态超标报警',
    icon: 'fa fa-users'
  },
  extends: BaseDateData,
  components: {DataWrapper},
  data () {
    return {
      query: {
        siteDeviceIds: []
      },
      currentQuery: Object.freeze({}),
      dataList: [],
      deviceStatusMap: {}
    }
  },
  computed: {
    queryTimeStep: () => 1,
    endTimeDiff: () => 0,
    filterSites () {
      let {profileSiteDevices} = this

      if (profileSiteDevices.length === 0) {
        return []
      }

      let {profileSites} = this

      if (profileSites.length === 0) {
        return []
      }

      let siteDeviceMap = profileSiteDevices.reduce((map, siteDevice) => {
        let {siteId} = siteDevice
        let siteDevices = map[siteId]

        if (!Array.isArray(siteDevices)) {
          siteDevices = map[siteId] = []
        }

        siteDevices.push(siteDevice)

        return map
      }, {})

      return Object.values(profileSites.reduce((map, site) => {
        let siteId = site.id

        if (siteDeviceMap.hasOwnProperty(siteId)) {
          map[siteId] = {
            value: siteId,
            label: site.name,
            children: siteDeviceMap[siteId].map(siteDevice => ({
              value: siteDevice.id,
              label: siteDevice.name
            }))
          }
        }

        return map
      }, {}))
    },
    filterSiteDeviceMap () {
      let data = this.filterSites.reduce((siteMap, item) => {
        siteMap[item.value] = item

        siteMap[item.value].devicesMap = item.children.reduce((map, el) => {
          map[el.value] = el

          return map
        }, {})

        return siteMap
      }, {})

      return data
    },
    canNotSearch () {
      return this.query.siteDeviceIds.length === 0
    }
  },
  methods: {
    setSiteDeviceIds (sites) {
      if (sites.length > 0) {
        let {query} = this

        if (query.siteDeviceIds.length === 0) {
          query.siteDeviceIds = sites[0].children.map(siteDevice => siteDevice.value)
        }

        setTimeout(() => {
          this.search()
        }, 0)
      }
    },
    search () {
      this.setCurrentQuery()
      this.getData()
    },
    setCurrentQuery () {
      this.currentQuery = Object.freeze(JSON.parse(JSON.stringify(this.query)))
    },
    getData () {
      let {currentQuery} = this
      this.changeLoadStatus(true)
      this.$api.OperationsAlarm.getDeviceList({
        beginTime: currentQuery.beginTime,
        endTime: currentQuery.endTime,
        isImportance: false,
        siteDeviceIds: currentQuery.siteDeviceIds
      }).then(this.setDataList).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    setDataList (dataList) {
      let {deviceStatusMap, filterSiteDeviceMap} = this

      dataList.forEach(data => {
        let deviceStatus = deviceStatusMap[data.deviceStatusId]
        data.deviceStatusName = deviceStatus.name
        data.unit = deviceStatus.unit ? deviceStatus.unit : ''
        data.siteName = filterSiteDeviceMap[data.siteId].label
        data.siteDeviceName = filterSiteDeviceMap[data.siteId].devicesMap[data.siteDeviceId].label
        data.ts = new Date(data.dataTime).getTime()
      })

      dataList.sort((a, b) => a.ts - b.ts)

      this.dataList = dataList
    },
    onSearchBtnClick () {
      this.search()
    }
  },
  watch: {
    filterSites: {
      immediate: true,
      handler (newVal) {
        this.setSiteDeviceIds(newVal)
      }
    }
  },
  created () {
    this.$api.DeviceStatus.getList().then(data => {
      this.deviceStatusMap = data.reduce((map, el) => {
        map[el.id] = el

        return map
      }, {})
    }).catch(console.error)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/08Operations/06Alarm/02StatusExcessive/index.vue